<i18n src="../../locales/lang.json"></i18n>

<template>
  <div class="container-fluid p-0">
    <component is="style" v-if="format">
      
      .select_container_{{getId()}} .select2-selection {
      border:none !important;
      }
      .select_procedure{{getId()}}>.select2-search--dropdown>.select2-search__field {
      padding-left:.4375rem
      }
      .select_procedure{{getId()}}>.select2-search--dropdown:after {
      display:none
      }
    </component>
    <div class="row">
      <div class="col px-0 ">
        <div class="select_container" v-bind:class="'select_container_' + getId()" style="float:left">
          <select required class="form-control" v-bind:id="'select_procedure' +  getId()" data-fouc>
            <option value="" style="">{{placeholder}}</option>
            <option v-for="option in items" v-bind:value="option.Id">
              {{ option.Name }}
            </option>
          </select>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

  var items = [];
  var itemName = "";

  export default {
    name: "procedure-selector-with-add",
    props: {
      placeholder: {
        type: String,
        default: "Select Procedure"
      },
      data: {
        type: String,
        default: null
      },
      format: {
        type: Boolean,
        default: false
      },
    },
    data() {
      return {
        itemName,
        items
      };
    },
    methods: {
      clearFields() {
        $("#select_procedure" + this.getId()).val('');
        $("#select_procedure" + this.getId()).trigger('change');
      },
      selectProcedure(selected) {
        $("#select_procedure" + this.getId()).val(selected);
        $("#select_procedure" + this.getId()).trigger('change');
      },
      onChange(e) {
        var data = $('#select_procedure' + this.getId()).select2('data');
        if (data.length == 0)
        {
          if ($('#select_procedure' + this.getId()).data("select2").dropdown.$search.val() == "")
          {
            $('#select_procedure' + this.getId()).val('')
            return;
          }
          this.$emit('event-add-procedure', $('#select_procedure' + this.getId()).data("select2").dropdown.$search.val());
        }
        else
          this.$emit('event-change-procedure', $("#select_procedure" + this.getId()).val(), this.data);
      },
      getId() {
        return this._uid;
      },
      doChange() {
      },
      async load() {
        var thisContext = this;
        try {
          this.items = [];
          this.$http.get('/api/Procedures/v1/GetProcedures').then(async response => {

            this.items = response.data;

            if (this.items !== null && this.items.length > 0) {
              this.items = this.items.sort(function (a, b) {
                if (!a.Name || a.Name == null)
                  a.Name = "";
                if (!b.Name || b.Name == null)
                  b.Name = "";
                var x = a.Name.toLowerCase();
                var y = b.Name.toLowerCase();
                return x < y ? -1 : x > y ? 1 : 0;
              });
              
            }

            var select = $('#select_procedure' + this.getId()).select2({
              dropdownCssClass: "select_procedure" + this.getId(),
              selectionCssClass: "selectionclass_procedure" + this.getId(),
              templateResult: function (el) {
                if (el.id == "")
                  return null;
                else if(el.id == -1)
                  return $('<a href="#">' + el.text + '</a>');
                return el.text
              },
              sorter: function (data) {
                if (data.length > 0) {
                  data.unshift({ text: thisContext.$t("add"), id: '-1', value: '-1'});
                }
                return data;
              },
              language: {
                noResults: function (term) {
                  var obj = $("<a href='#'>" + thisContext.$t("add") + "</a>");
                  obj.on("click", function () {
                    thisContext.$emit('event-add-procedure', $('#select_procedure' + thisContext.getId()).data("select2").dropdown.$search.val());
                  });
                  return obj;
                }
              }
            });

            $(select).on('select2:opening', function (e) {
              /*
              items = e.items.results;
              if (items.length == 1) {
                $(this).val(items[0].text);
                $(".select").select2('close');
              }
              */
              //$(this).select2('container').find('.select2-search--dropdown:after').css(
              //  {
              //    'display': 'none;'
              //  });
            });

            

          }).then((async response => {
            //$("#select_procedure" + this.getId()).val(selected);
            //$("#select_procedure" + this.getId()).trigger('change');
          }
          ));
        } catch (err) {
          //alert('some error:' + err)
        }
      }
    },
    watch: {

    },
    mounted() {
      this.load();
      
      $("#select_procedure" + this.getId()).change(this.onChange);

      if (this.format == true) {
        this.placeholder = this.$t("select_create_task")
      }
      else
        this.placeholder = this.$store.translate("select_template");
      
      //$("#select_procedure" + this.getId()).select2('container').find('.select2-search--dropdown:after').css(
      //  {
      //    'display': 'none;'
      //  });

      this.$root.$on('procedures_reload', this.load);
    }
  };
</script>

<style scoped>
  .select_container {
    width: 100%;
  }
  .select_container select option[selected=selected] {
    color: #000;
    background: green;
  }
</style>




// WEBPACK FOOTER //
// src/components/procedure/procedure-selector-with-add.vue